// extracted by mini-css-extract-plugin
export default {"container":"AdminComponent__container--3w1","item":"AdminComponent__item--2rq"};